import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionsKey, getMemberNotificationSettingsKey, getSpacesKey, } from '../../utils/keys';
export const useDeleteSpace = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const collectionsKey = getCollectionsKey();
    const spacesKey = getSpacesKey();
    const memberNotificationSettingsKey = getMemberNotificationSettingsKey();
    return useMutation(input => client.spaces.delete(input, fields), {
        onSuccess: () => {
            queryClient.invalidateQueries(memberNotificationSettingsKey);
            queryClient.invalidateQueries(spacesKey);
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useDeleteSpace.js.map